import React, { useEffect, useState } from 'react';
import { useApi } from 'src/hooks/useApi';
import LoadingSpinner from 'src/components/LoadingSpinner';
import { useNavigate } from 'react-router';
import { ArtifactDetailModal } from 'src/components/ArtifactDetail/components/ArtifactDetailModal';
import './artifact-detail-overrides.scss';
import { GetArtifactDetailApiType } from 'src/types/useApi';
import { useRenderContent } from 'src/components/ArtifactDetail/components/useRenderContent';

type ArtifactDetailProps = {
    artifactId: string;
    contentObjectLcmsXmlGUID: string;
};

const ArtifactDetail = ({
    artifactId,
    contentObjectLcmsXmlGUID,
}: ArtifactDetailProps) => {
    const navigate = useNavigate();
    const [modalHref, setModalHref] = useState<string>('');

    const {
        makeRequest: getDocumentHTML,
        data,
        error,
        loading,
    }: GetArtifactDetailApiType = useApi({
        method: 'GET',
    });

    const baseDynamicURL = `https://core-ar.bravais.com/api/dynamic/documentVersions/${
        data && data.latestId
    }/contentObjects/${data && data.latestLcmsXmlID}/`;

    useEffect(() => {
        if (error) {
            navigate('/error');
        }
    }, [error]);

    useEffect(() => {
        if (artifactId && contentObjectLcmsXmlGUID) {
            getDocumentHTML({
                url: `/learning-artifacts/document/${artifactId}/${contentObjectLcmsXmlGUID}`,
            });
        }
    }, [artifactId, contentObjectLcmsXmlGUID]);

    const { artifactHtml } = useRenderContent({
        data,
        baseDynamicURL,
        artifactId,
        setModalHref,
        loading,
    });
    return loading || artifactId === '' ? (
        <LoadingSpinner />
    ) : (
        <>
            {modalHref && (
                <ArtifactDetailModal
                    modalHref={modalHref}
                    setModalHref={setModalHref}
                    artifactId={artifactId}
                    latestId={data && data.latestId}
                    latestLcmsXmlID={data && data.latestLcmsXmlID}
                />
            )}
            <object className={'xyleme-container'}>{artifactHtml}</object>
        </>
    );
};

export default ArtifactDetail;
